import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import Container from "@scentregroup/ui/components/container";
import Card from "@scentregroup/ui/components/card";
import classNames from 'classnames';
import Article from '../article';
import Markdown from '../markdown';
import { CustomThemeContext } from '../../context';
import ServiceUtilityBox from '../service-utility-box';
import Trackable from '../trackable';
import { trackingActions, trackingTypes } from '../../constants';
import style from '../feature/index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ServiceFeature = _ref => {
  let {
    position,
    title,
    body,
    centred = false,
    centre,
    centreTradingHours,
    analyticsMetadata
  } = _ref;
  return /*#__PURE__*/_jsx(Trackable, _objectSpread(_objectSpread({}, analyticsMetadata), {}, {
    trackingAction: trackingActions.viewPromotion,
    type: trackingTypes.promotion,
    "data-id": "service-feature_index_ServiceFeature_Trackable",
    children: /*#__PURE__*/_jsx(CustomThemeContext.Consumer, {
      children: themeOption => /*#__PURE__*/_jsx("div", {
        className: classNames(style.Feature, style.ServiceFeature, style.placeholder, {
          [style.Grey]: themeOption.luxury,
          [style.evolved]: true
        }),
        "data-id": "service-feature_index_ServiceFeature_div",
        children: /*#__PURE__*/_jsxs(Container, {
          centred: true,
          type: "large",
          className: classNames(style.Container, style[position]),
          "data-id": "service-feature_index_ServiceFeature_div_Container",
          children: [/*#__PURE__*/_jsx(Card, {
            className: classNames(style.Card, {
              [style.centred]: centred
            }),
            "data-id": "service-feature_index_ServiceFeature_Container_Card",
            children: /*#__PURE__*/_jsx(Article, {
              headingType: 'medium',
              superheading: undefined,
              heading: title,
              "data-id": "service-feature_index_ServiceFeature_Card_Article",
              children: /*#__PURE__*/_jsx(Markdown, {
                content: body,
                "data-id": "service-feature_index_ServiceFeature_Article_Markdown"
              })
            })
          }), /*#__PURE__*/_jsx("div", {
            className: style.Sidebar,
            "data-id": "service-feature_index_ServiceFeature_Container_div",
            children: /*#__PURE__*/_jsx(ServiceUtilityBox, {
              centre: centre,
              centreTradingHours: centreTradingHours,
              storeTradingHours: centre.conciergeService && centre.conciergeService.store ? centre.conciergeService.store.storeTradingSchedule : undefined,
              "data-id": "service-feature_index_ServiceFeature_div_ServiceUtilityBox"
            })
          })]
        })
      })
    })
  }));
};
export default ServiceFeature;